import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Category } from '../types/category.type';
import { ADMIN_CATEGORIES_API_PATHS } from '../constants/categories-api-paths.constants';

type UseArchiveCategoryResult = {
  archiveCategory: (categoryId: string) => Promise<Category | null>;
  isSubmitting: boolean;
};

export function useArchiveCategory(): UseArchiveCategoryResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const archiveCategory = async (categoryId: string): Promise<Category | null> => {
    setIsSubmitting(true);

    try {
      const archivedCategory = await HttpClient.delete<Category>(
        ADMIN_CATEGORIES_API_PATHS.ARCHIVE_CATEGORY(categoryId)
      );

      enqueueSnackbar('Rubrique archivée', { variant: 'success' });
      return archivedCategory;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'archivage de la rubrique"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { archiveCategory, isSubmitting };
}
